module.exports = __webpack_public_path__ + "img/Grillwürstchen.48e28be3.jpg";